import styled from 'styled-components';
import { COLORS } from '../styles/variables';
import { device } from '../styles/devices';

export const DigitalLeadsWrapper = styled.section``;

export const BlackBackground = styled.div`
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
`;

export const DigitalLeadsModal = styled.div`
  width: 375px;
  background-color: ${COLORS.white};
  position: fixed;
  overflow-y: auto;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  left: 50%;
  transform: translateX(-50%);
  padding: 40px 16px 60px 16px;
  z-index: 101;
  /* top: 0; */
  top: 24px;
  bottom: 24px;
  @media ${device.tablet} {
    height: auto;
    padding: 36px 48px 48px 48px;
    gap: 40px;
    width: 768px;
    top: 40px;
    bottom: 40px;
  }
  @media ${device.laptop} {
    padding: 48px 60px 60px 60px;
    gap: 36px;
    width: 1024px;
    top: 60px;
    bottom: 60px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: center;
  gap: 48px;
  width: 100%;
  @media ${device.tablet} {
    gap: 0;
    flex-direction: row;
    justify-content: space-between;
  }
  @media ${device.laptop} {
  }
`;
export const Sticky = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  z-index: 5;
`;

export const CloseModal = styled.button<{ isResultModal?: boolean }>`
  width: 48px;
  height: 48px;
  position: absolute;
  top: ${({ isResultModal }) => (isResultModal ? '0' : '-40px')};
  right: ${({ isResultModal }) => (isResultModal ? '0' : '-16px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: initial;
  border: none;

  @media ${device.tablet} {
    right: ${({ isResultModal }) => (isResultModal ? '0' : '-48px')};
    /* right: -48px; */
  }
`;
export const Header = styled.h1`
  font-family: Audi Type Extended;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.002px;
  color: ${COLORS.black};
  padding-top: 20px;

  @media ${device.laptop} {
    padding-top: 0;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 0.003px;
  }
`;

export const InputSection = styled.section`
  @media ${device.tablet} {
    border-right: 1px solid ${COLORS.grey15};
    width: 390px;
    padding-right: 48px;
  }
  @media ${device.laptop} {
    flex-grow: 1;
    width: 540px;
    padding-right: 60px;
  }
`;

export const Inputs = styled.div``;

export const InputField = styled.div`
  @media ${device.laptop} {
    width: 353px;
  }
`;

export const VehicleDetailSection = styled.section`
  width: 100%;
  @media ${device.tablet} {
    width: 282px;
    margin-left: 48px;
  }
  @media ${device.laptop} {
    width: 300px;
    margin-left: 60px;
  }
`;
export const Title = styled.h2`
  font-family: Audi Type Extended;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.002px;
  color: ${COLORS.black};
  @media ${device.tablet} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const SectionWrapper = styled.section`
  margin-bottom: 60px;
`;
